import { Navigate } from 'react-router-dom';
import { useState } from 'react';
import { standardDate } from '../../../utils/formatDate';
import EmptyPage from '../../../components/empty-page/emptyPage';

export default function DashboardTableCustom({ tableData }) {
    const tableHeader = ['Trip Name', 'Booked On', 'Booked By', 'City', 'Pickup Location', 'Seats', 'Booked Via'];
    const [rowClickId, setRowClickId] = useState(0);

    if (rowClickId !== 0) {
        const tabeleDataById = tableData.find((tableDataItem) => tableDataItem?._id === rowClickId);
        const packId = tabeleDataById?.packId?._id;
        const startDate = tabeleDataById?.startDate.split('T')[0];
        window.open(`/org/trip/date/${packId}/${startDate}`);
        setRowClickId(0);
    }

    const getTripDetails = (row) => {
        return (
            <div className='bookingTitleArea'>
                <div>{row?.packId?.title ?? 'N/A'}</div>
                <div>
                    {standardDate(row?.startDate?.split('T')[0])} (
                    {`${row?.packId?.days ?? '(N/A)'}D/${row?.packId?.nights ?? '(N/A)'}N`})
                </div>
            </div>
        );
    };

    const getUserDetails = (row) => {
        return (
            <div>
                <div>
                    {row?.userDetails[0]?.name ?? 'N/A'} ({row?.userDetails[0]?.sex ?? 'N/A'} -{' '}
                    {row?.userDetails[0]?.age ?? 'N/A'})
                </div>
                <div>{row?.userDetails[0]?.phoneNumber ?? 'N/A'}</div>
            </div>
        );
    };

    const customBookingData = tableData.filter((item) => item.packDateId === null);

    return (
        <>
            {customBookingData.length === 0 ? (
                <EmptyPage></EmptyPage>
            ) : (
                <div className='table-top-container'>
                    <table className='table'>
                        <thead className='tableHead'>
                            <tr>
                                {tableHeader.map((head, headIndex) => {
                                    return <th key={headIndex}>{head}</th>;
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {customBookingData?.map((row, rowIndex) => {
                                return (
                                    <tr
                                        key={rowIndex}
                                        className={
                                            row?.tripStatus === 'Cancelled'
                                                ? 'tableBodyCancelledRow'
                                                : 'tableBodyRow allowCLick'
                                        }
                                        onClick={() => setRowClickId(row._id)}
                                    >
                                        <td>{getTripDetails(row)}</td>
                                        <td>{standardDate(row?.createdAt?.split('T')[0]) ?? 'N/A'}</td>
                                        <td>{getUserDetails(row)}</td>
                                        <td>{row.startCity ?? 'N/A'}</td>
                                        <td>{row.pickupLocation ?? 'N/A'}</td>
                                        <td>{row.totalSeats}</td>
                                        <td>{row.bookedVia ?? 'N/A'}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <div className='responsiveCardContainer'>
                        {customBookingData?.map((row, rowIndex) => (
                            <div key={rowIndex} className='responsiveCard' onClick={() => setRowClickId(row._id)}>
                                <div className='cardContent'>
                                    <p>
                                        <strong>{tableHeader[0]}</strong> {getTripDetails(row)}
                                    </p>
                                    <p>
                                        <strong>{tableHeader[1]}</strong>{' '}
                                        {standardDate(row?.createdAt?.split('T')[0]) ?? 'N/A'}
                                    </p>
                                    <p>
                                        <strong>{tableHeader[2]}</strong> {getUserDetails(row)}
                                    </p>
                                    <p>
                                        <strong>{tableHeader[3]}</strong> {row.startCity ?? 'N/A'}
                                    </p>
                                    <p>
                                        <strong>{tableHeader[4]}</strong> {row.pickupLocation ?? 'N/A'}
                                    </p>
                                    <p>
                                        <strong>{tableHeader[5]}</strong> {row.totalSeats}
                                    </p>
                                    <p>
                                        <strong>{tableHeader[6]}</strong> {row.bookedVia ?? 'N/A'}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
}
